






























import Vue from "vue";
import Component from "vue-class-component";
import ArrowLeftIcon from "vue-material-design-icons/ArrowLeft.vue";

@Component({
    components: { ArrowLeftIcon },
})
export default class Header extends Vue {

    public get historyButton() {
        return this.$store.state.history_button;
    }
}
